<template>
    <div class="todoList-module">
        <div class="select-box flex-y-center flex-start">
            <div class="select-item flex-between flex-y-center mr-20" @click="selectEmployeePopup"
                v-if="postId==1||postId=='1472787652026765367'||regionPostId.includes(this.postId)">
                <div class="select-tit">{{ checkedEmployee && checkedEmployee.name }}</div>
                <van-icon name="play" class="select-arrow" />
            </div>
            <div class="select-item flex-1 flex-start flex-y-center" @click="selectTimePopup">
                <div class="select-tit">{{ dateTxt }}</div>
                <van-icon name="play" class="select-arrow" />
            </div>
            <div class="select-item flex-between flex-y-center" @click="selectSortPopup">
                <div class="select-tit">{{ checkedSort && checkedSort.name }}</div>
                <van-icon name="play" class="select-arrow" />
            </div>
        </div>
        <van-pull-refresh v-model="refreshing" success-text="刷新成功" @refresh="onRefresh">
            <div class="list-box" v-if="todoEventList.length != 0">
                <div class="list-item flex-col flex-y-center" v-for="item, index in todoEventList" :key="index">
                    <div class="list-item-top flex-between flex-y-center" @click="toNewDetail(item.employeeId, item.name)">
                        <img class="head-img" :src="item.avatar" alt="">
                        <div class="flex-1 top-tit">{{ item.name }}</div>
                        <van-icon name="arrow" class="arrow" />
                    </div>
                    <div class="list-item-bottom flex-between flex-y-center">
                        <div class="bottom-item">
                            待完成：<span class="bottom-txt">{{ item.unfinished }}</span>
                        </div>
                        <div class="bottom-item">
                            已完成：<span class="bottom-txt">{{ item.finished }}</span>
                        </div>
                        <div class="bottom-item flex-1">
                            完成率：<span :class="`bottom-txt ${item.finishedRatio < 50 ? 'red' : ''}`">{{
                                item.finishedRatio
                            }}%</span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="flex flex-col flex-y-center">
                <img src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-14/null.png"
                    class="empty-icon" alt="" />
                <div class="empty-txt">暂无</div>
            </div>
        </van-pull-refresh>

        <van-popup v-model="showEmployeePopup" round position="bottom" closeable class="popup">
            <picker :title="employeePopupTitle" v-model="checkedEmployee" :list="employeeList" @change="onEmployeeChange">
            </picker>
        </van-popup>
        <van-popup v-model="showTimePopup" round position="bottom" closeable class="popup">
            <date-picker v-model="dateType" @submit="handleDate" :pickerType="pickerType"></date-picker>
        </van-popup>
        <van-popup v-model="showSortPopup" round position="bottom" closeable class="popup">
            <picker title="排序" v-model="checkedSort" :list="sortList" @change="onSortChange"></picker>
        </van-popup>
    </div>
</template>

<script>
import request from "@/utils/request";
import DatePicker, { getDateText, getFormatTime, PICKER_TYPE } from '@/components/DatePicker';
import Picker from '@/components/Picker';
import { getCookie } from '@/utils'
import { Toast } from 'vant'
import { mapState } from 'vuex'
import { keepAliveAfterHandler } from "@/router/router";
const SORT_LIST = [{ name: '升序', id: 1 }, { name: '降序', id: 2 }]
export default {
    name: 'employeeToDo',
    components: {
        DatePicker,
        Picker
    },
    data() {
        return {
            pickerType: PICKER_TYPE.MONTH,// 日期类型
            refreshing: false,// 刷新
            page: 1, // 分页
            total: 0,
            todoEventList: [],// 待办列表
            showTimePopup: false, // 选择时间弹窗
            showEmployeePopup: false, // 选择员工弹窗
            showSortPopup: false, // 排序
            dateType: '2', // 日期
            beginMonth: '', // 开始日期
            endMonth: '', // 结束日期
            sortList: SORT_LIST, // 排序
            checkedSort: SORT_LIST[0],
            employeeList: [], // 员工
            checkedEmployee: null,
            postId: '',//权限
            employeePopupTitle: ''
        }
    },
    watch: {
    },
    computed: {
        ...mapState({
            regionPostId: (state) => {
                return state.user.permissions.regionPostId
            },// 区经区总id
        }),
        dateTxt() {
            return getDateText(this.dateType, this.beginMonth, this.endMonth, this.pickerType)
        }
    },
    beforeRouteLeave(to, from, next) {
        keepAliveAfterHandler.call(this, to, from)
        next()
    },
    mounted() {
        document.title = this.$route.query.typeName
        this.dimension = JSON.parse(localStorage.getItem('employeeInfo')).dimension
        this.postId = getCookie('postId') || localStorage.getItem('postId');
        this.employeePopupTitle = this.dimension == 1 ? '全部员工' : '主诊人' // 选择器标题
        this.getEmpList()
    },
    methods: {
        init() {
            // 初始化data的值
            Object.assign(this.$data, this.$options.data())
            this.getToDoList()
        },
        // 获取待办列表
        getToDoList() {
            const beginDate = getFormatTime(this.beginMonth, this.pickerType)
            const endDate = getFormatTime(this.endMonth, this.pickerType)
            let params = {
                beginMonth: beginDate,
                endMonth: endDate,
                dateType: this.dateType,
                type: this.$route.query.type,
                orderField: this.checkedSort.id,
                employeeId: this.checkedEmployee.id,
            }
            if (this.regionPostId.includes(this.postId)) {
                params.id = this.$route.query.id
                params.storeId = this.$route.query.storeId
            }
            request({
                url: "/todo/employeeFinishedStatistic",
                method: "get",
                params: params
            })
                .then((res) => {
                    this.data = res.data
                    this.todoEventList = res.data
                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                })
        },
        // 获取员工列表
        getEmpList() {
            let params = null
            if (this.regionPostId.includes(this.postId)) {
                params = {
                    id: this.$route.query.id,
                    storeId: this.$route.query.storeId
                }
            }
            request({
                url: "/sys/params/selectByStoreTreasure",
                method: "get",
                params: params
            })
                .then((res) => {
                    this.employeeList = res.data
                    this.checkedEmployee = this.employeeList[0] //默认全部
                    this.getToDoList()
                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                })
        },
        // 刷新
        onRefresh() {
            this.refreshing = false;
        },
        // 弹窗
        selectTimePopup() {
            this.showTimePopup = true
        },
        selectEmployeePopup() {
            this.showEmployeePopup = true
        },
        selectSortPopup() {
            this.showSortPopup = true
        },
        // 筛选相关
        handleDate(id, begin, end) {
            this.showTimePopup = false
            this.dateType = id
            if (!id) {
                this.beginMonth = begin
                this.endMonth = end
            } else {
                this.beginMonth = ''
                this.endMonth = ''
            }
            this.getToDoList()
        },
        onEmployeeChange(data) {
            this.checkedEmployee = data
            this.showEmployeePopup = false
            this.getToDoList()
        },
        onSortChange(data) {
            this.showSortPopup = false
            this.checkedSort = data
            this.getToDoList()
        },
        // 跳转详情
        toNewDetail(employeeId, name) {
            let checkedType = {
                id: this.$route.query.type,
                name: this.$route.query.typeName
            }
            let employee = {
                id: employeeId,
                name: name
            }
            this.$router.push({
                name: 'toDoNewDetail', query: {
                    id: this.$route.query.id,
                    storeId: this.$route.query.storeId, employee: JSON.stringify(employee), checkedType: JSON.stringify(checkedType)
                }
            });
        }
    },
}
</script>

<style scoped lang="less">
.mr-20 {
    margin-right: 20px;
}

::-webkit-scrollbar {
    display: none;
}

.todoList-module {
    height: 100%;
    background-color: #ffffff;
    overflow-y: auto;
}

.main-box {
    padding: 30px;
    height: 100%;
}

.select-box {
    z-index: 99;
    padding: 30px;

    .select-item {
        margin-right: 15px;
    }

    .select-tit {
        font-size: 28px;
        color: #35434c;
    }

    .select-arrow {
        transform: rotate(90deg);
        font-size: 24px;
        margin-left: 10px;
    }
}

.list-box {
    min-height: calc(100vh - 102px);
    padding: 30px;
    padding-top: 0;

    .list-item {
        width: 690px;
        height: 200px;
        background: #fafafe;
        border-radius: 20px;
        padding: 20px 30px 20px 20px;
        margin-bottom: 20px;

        .list-item-top {
            width: 100%;

            .head-img {
                width: 90px;
                height: 90px;
                border-radius: 50%;
                margin-right: 20px;
            }

            .top-tit {
                font-size: 30px;
                font-weight: 700;
                color: #35434c;
            }

            .arrow {
                font-size: 32px;
                color: #cccccc;
            }
        }

        .list-item-bottom {
            width: 100%;
            margin-top: 30px;

            .bottom-item {
                width: 35%;
                height: 40px;
                font-size: 28px;
                font-weight: 400;
                color: #a0acb5;

                .bottom-txt {
                    font-size: 28px;
                    font-weight: 700;
                    color: #35434c;
                }

                .bottom-txt.red {
                    color: #ff7777;
                }
            }
        }
    }
}

.empty-icon {
    width: 280px;
    height: 280px;
    margin-top: 179px;
}

.empty-txt {
    font-size: 30px;
    color: #a0acb5;
}

:deep(.van-popup__close-icon--top-right) {
    top: 50px;
}
</style>
